// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD87e_1N50NMGxUovOP7FFkdCblmPpx0hE",
    authDomain: "hkaict-web.firebaseapp.com",
    projectId: "hkaict-web",
    storageBucket: "hkaict-web.appspot.com",
    messagingSenderId: "864984799794",
    appId: "1:864984799794:web:e4fddd0fe8fc220f363a2b",
    measurementId: "G-E09WDVWMKX",
};

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);
const database = getFirestore(app);

export { app, auth, googleProvider, storage, database };
